var external_event_popup = (function( $ ) {

	var $anchors;

	var _init = function() {
		$anchors = $( 'a.external-event-button' );

		if ( $anchors.length > 0 ) {
			$anchors.on( 'click', _show_popup );
		}
	};

	var _show_popup = function( e ) {
		e.preventDefault();

		var $popup_overlay = $( '#external-event-popup .crate-popup-overlay' );
		var $popup  = $( '#external-event-popup .exit-popup' );

		var $body = $( 'body' );

		$body.addClass( 'popup-open' );

		$popup_overlay.fadeIn();
		$popup.fadeIn();
		$popup.addClass( 'open' );

		$popup_overlay.on( 'click', _close_popup );
		$popup.find( 'a.close-popup' ).on( 'click', _close_popup );
		$popup.find( 'a.continue-booking' ).on( 'click', _close_popup );
		$popup.find( 'a.cancel-booking' ).on( 'click', _close_popup );
	};

	var _close_popup = function( e ) {
		if ( ! $( this ).hasClass( 'continue-booking' ) ) {
			e.preventDefault();
		}

		$( 'body' ).removeClass( 'popup-open' );

		var $popup = $( '.exit-popup' );
		var $popup_overlay = $( '.crate-popup-overlay' );

		$popup.fadeOut( 400 );
		$popup.removeClass( 'open' );
		$popup_overlay.fadeOut( 400 );
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = external_event_popup;